/*eslint-disable*/
import $urls from "../urls/url";
import $api from "../axios/index";
import $Cookies from "js-cookie";
import store from "@/common/store/";
import format from "timestamp-format";
import { commonApi } from "@/common/index";
import { Toast } from "vant";

// 老虎机使用jpg图片的平台
const jpgArr = ["mg", "dt", "jdb"];
let lang = function () {
  return $Cookies.get("lang");
};

const CryptoJS = require("crypto-js"); //引用AES源码js
const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse("ABCDEF1234123412"); //十六位十六进制数作为密钥偏移量
//解密方法
export function Decrypt(word) {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

//加密方法
export function Encrypt(word) {
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString().toUpperCase();
}
// 平台排序
export function setListOrder(array, order) {
  let obj = {};
  let wraplist = {};
  let arr = [];
  let newarr = [];
  let newarr2 = [];
  let gametype = array[0].gameType;
  if (order.length == 0) {
    return array;
  }
  if (array.length >= order.length) {
    for (let i = 0; i < array.length; i++) {
      obj[i] = [];
      wraplist[i] = [];
    }
  } else {
    for (let i = 0; i < order.length; i++) {
      obj[i] = [];
      wraplist[i] = [];
    }
  }

  order.forEach(function (element, index) {
    for (let i = 0; i < array.length; i++) {
      if (element == array[i].platformKey) {
        // console.log(  obj[0],obj[1],obj[2],obj[3],obj[4] )

        obj[index].push(array[i]);
      }
    }
  });

  array.forEach(function (element, index) {
    for (let i = 0; i < order.length; i++) {
      if (element.platformKey !== order[i]) {
        wraplist[index].push(element);
      }
    }
  });
  for (let key in wraplist) {
    if (wraplist[key].length == order.length) {
      arr.push(wraplist[key]);
    }
  }
  for (let key in obj) {
    if (obj[key].length > 0) {
      newarr2.push(obj[key][0]);
    }
  }
  if (gametype == "1") {
    newarr2.forEach((item, index) => {
      if (index < 4) {
        item.hot = true;
      }
    });
  } else if (gametype == "2") {
    newarr2.forEach((item, index) => {
      if (index < 3) {
        item.hot = true;
      }
    });
  } else if (gametype == "6") {
    newarr2.forEach((item, index) => {
      if (index < 2) {
        item.hot = true;
      }
    });
  } else if (gametype == "5") {
    newarr2.forEach((item, index) => {
      if (index < 2) {
        item.hot = true;
      }
    });
  } else if (gametype == "3") {
    newarr2.forEach((item, index) => {
      if (index < 3) {
        item.hot = true;
      }
    });
  }
  arr.forEach(function (item) {
    newarr.push(item[0]);
  });
  return newarr2.concat(newarr);
}
//平台热门排序
export function setHotOrder(array, order) {
  let obj = {};
  let newarr2 = [];
  for (let i = 0; i < array.length; i++) {
    obj[i] = [];
  }
  order.forEach(function (element, index) {
    for (let i = 0; i < array.length; i++) {
      if (element == array[i].platformKey) {
        obj[index].push(array[i]);
      }
    }
  });
  for (let key in obj) {
    if (obj[key].length > 0) {
      newarr2.push(obj[key][0]);
    }
  }
  return newarr2;
}
// 存款链接
export function depositUrl(params) {
  if (params.payType !== "IB" && params.payType !== "BK") {
    // 选择平台的支付方式
    window.open(
      `${params.payDomain}?payConfigId=${params.payConfigId}&amount=${
        params.amount
      }&payType=${params.payType}&uuId=${params.userId}&lang=${lang()}`
    );
  } else if (params.payType === "IB") {
    // 选择IB
    window.open(
      `${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${
        params.payConfigId
      }&amount=${params.amount}&payType=${params.payType}&uuId=${
        params.userId
      }&lang=${lang()}`
    );
  } else if (params.payType === "BK") {
    window.open(
      `${params.payDomain}?payType=${params.payType}&uuId=${
        params.userId
      }&lang=${lang()}`
    );
  }
}
// 新存款链接
export function newDepositUrl(params) {
  let domain = window.location.origin;
  if (params.payType !== "IB" && params.payType !== "BK") {
    // 选择平台的支付方式

    // if(!params.amount){
    //   window.open(`${params.payDomain}?payConfigId=${params.payConfigId}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}`)
    // }else{
    //   window.open(`${params.payDomain}?payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}`)
    // }

    window.open(
      `${params.payDomain}?payConfigId=${params.payConfigId}&amount=${
        params.amount
      }&payType=${params.payType}&uuId=${
        params.userId
      }&domain=${domain}&remark=${params.remark}&lang=${lang()}`
    );
  } else if (params.payType === "IB") {
    // 选择IB
    // if(!params.amount){
    //   window.open(`${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}`)
    // }else{
    //   window.open(`${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}`)
    // }

    window.open(
      `${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${
        params.payConfigId
      }&amount=${params.amount}&payType=${params.payType}&uuId=${
        params.userId
      }&domain=${domain}&remark=${params.remark}&lang=${lang()}`
    );
  } else if (params.payType === "BK") {
    window.open(
      `${params.payDomain}?payType=${params.payType}&uuId=${
        params.userId
      }&domain=${domain}&lang=${lang()}`
    );
  }
}
// 新支付存款链接(BK类型)
export function newDepositBankUrl(payType, UUID, payDomain) {
  let domain = window.location.origin;
  window.open(
    `${payDomain}?payType=${payType}&uuId=${UUID}&domain=${domain}&lang=${lang()}`
  );
}
// build24
export function ForenewDepositUrl(params) {
  let domain = window.location.origin;
  window.open(
    `${params.payDomain}?payType=${params.payType}&uuId=${
      params.userId
    }&domain=${domain}&lang=${lang()}`
  );
}
// 银行存款链接
export function bankurl(params) {
  window.location.href = `${params.payDomain}?payType=${params.payType}&uuId=${
    params.userId
  }&lang=${lang()}`;
}
// 随机字符串
export function randomRange(min, max) {
  var returnStr = "",
    range = max ? Math.round(Math.random() * (max - min)) + min : min,
    arr = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
  for (var i = 0; i < range; i++) {
    var index = Math.round(Math.random() * (arr.length - 1));
    returnStr += arr[index];
  }
  return returnStr;
}
export function loginOut() {
  let UUID = $Cookies.get("UUID");
  if (UUID) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.USER.LOGINOUT,
        {
          UUID: UUID,
        },
        (resp) => {
          if (resp.data.code === 200) {
            $Cookies.remove("UUID");
            store.dispatch("checkLogin");
            resolve("退出登录");
          } else {
            reject(resp.data.msg);
          }
        },
        (err) => {
          reject(err.message);
        }
      );
    });
  }
}
export function getInfo(level, proportion, limit) {
  let levels = level.split(",");
  let proportions = proportion.split(",");
  let limits = limit.split(",");
  let arr = [];
  levels.forEach((item, index) => {
    let obj = {};
    obj["level"] = levels[index];
    obj["scale"] = proportions[index];
    obj["max"] = limits[index];
    arr.push(obj);
  });
  return arr;
}
export function serverInfo() {
  return new Promise((resolve, reject) => {
    $api.post(
      $urls.HOMEBEFORE.serverInfo,
      {},
      (resp) => {
        if (resp.data.code === 200) {
          let serverInfo = resp.data.data.serverInfo;
          let picLink = serverInfo.ftpDomain;
          resolve(picLink);
        } else {
          reject(resp.data.msg);
        }
      },
      (err) => {
        reject(err.message);
      }
    );
  });
}
export function gamePlatform() {
  return new Promise((resolve, reject) => {
    let gameType = 1;
    let pageNo = 1;
    let pageSize = 10;
    let params = {
      gameType: gameType,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    $api.post(
      $urls.GAME.gamePlatform,
      params,
      (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data.list;
          let data = {
            gameForm: gameForm,
          };
          resolve(data);
        } else {
          reject(resp.data.msg);
        }
      },
      (err) => {
        reject(err.message);
      }
    );
  });
}
export function getMyslot(UUID) {
  return new Promise((resolve, reject) => {
    let datas = [];
    let params = {
      frontType: 1,
      UUID: UUID,
      pageNo: -1,
      pageSize: 0,
    };
    if (UUID) {
      $api.post(
        $urls.SLOT.mySlot,
        params,
        (resp) => {
          if (resp.data.code === 200 || resp.data.code === 201) {
            if (resp.data.data === null || resp.data.data === undefined) {
              datas = [];
            } else {
              datas = resp.data.data.list;
            }
          } else if (resp.data.success === false) {
          }
          resolve(datas);
        },
        (err) => {
          reject(err.message);
        }
      );
    }
  });
}
export function isCollect(gameList, mySlot) {
  gameList.forEach((gamesItem) => {
    mySlot.forEach((myItem) => {
      if (gamesItem.id === myItem.id) {
        gamesItem["collect"] = true;
      }
    });
  });
  return gameList;
}

export function slotJoint(picLink, isLogin, UUID, resp) {
  // 收藏
  let src = isLogin ? "/game/forward" : "/game/guest/forward";
  let data = resp.data.data.list;
  let gameType = 1;
  if (data === null || data === []) {
    data = [];
    return data;
  } else {
    data.forEach((item) => {
      // if(item.platformCode==='HB'){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '_zh-CN.png';
      // }else if(jpgArr.includes(item.platformCode.toLowerCase())){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.jpg';
      // }else {
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.png';
      // }
      item["picLink"] = picLink + (item.h5Img ? item.h5Img : item.pcImg);
      item["href"] = `/api${src}?UUID=${UUID}&linkType=1&platformCode=${
        item.platformCode
      }&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${
        item.gameId
      }&lang=${lang()}`;
      item["collect"] = true;
    });
    return data;
  }
}

// 首页平台拼接
// goGame(item,isLogin,UUID) {
//   let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
//   let href =  `/api${src}?UUID=${UUID}&linkType=1&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}`;
//   if (isLogin) {
//     window.open(href);
//     return true
//   } else {
//
//     // goGameTip()
//     return false
//   }
// },
// goGameTip() {
//
// },

export function safetyIndex(obj) {
  let number = 4;
  let count = 0;
  let sum = 100;
  let unit = 25;
  if (obj.emailValid) {
    count += unit;
    number--;
  }
  if (obj.mobileValid) {
    count += unit;
    number--;
  }
  if (obj.nameValid) {
    count += unit;
    number--;
  }
  if (obj.withdrawPasswordValid) {
    count += unit;
    number--;
  }
  if (count === 0) {
    count = 20;
  }
  if (count === 100) {
    count -= 1;
  }
  count = (count / sum) * 100;
  return {
    count: count,
    number: number,
  };
}
export function getBrowserInfo() {
  let agent = navigator.userAgent.toLowerCase();
  let regStr_ie = /msie [\d.]+;/gi;
  let regStr_ff = /firefox\/[\d.]+/gi;
  let regStr_chrome = /chrome\/[\d.]+/gi;
  let regStr_saf = /safari\/[\d.]+/gi;
  let regStr_uc = /uc\/[\d.]+/gi;
  let regStr_QQ = /qq\/[\d.]+/gi;
  let regStr_baidu = /baidu\/[\d.]+/gi;
  let isIE = agent.indexOf("compatible") > -1 && agent.indexOf("msie" > -1); //判断是否IE<11浏览器
  let isEdge = agent.indexOf("edge") > -1 && !isIE; //判断是否IE的Edge浏览器
  let isIE11 = agent.indexOf("trident") > -1 && agent.indexOf("rv:11.0") > -1;
  if (isIE) {
    var reIE = new RegExp("msie (\\d+\\.\\d+);");
    reIE.test(agent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return "IE/7";
    } else if (fIEVersion == 8) {
      return "IE/8";
    } else if (fIEVersion == 9) {
      return "IE/9";
    } else if (fIEVersion == 10) {
      return "IE/10";
    }
  } //isIE end
  if (isIE11) {
    return "IE/11";
  }
  //firefox
  if (agent.indexOf("firefox") > 0) {
    return agent.match(regStr_ff);
  }
  //Safari
  if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
    return agent.match(regStr_saf);
  }
  //Chrome
  if (agent.indexOf("chrome") > 0) {
    return agent.match(regStr_chrome);
  }
  // uc
  if (agent.indexOf("UCBrowser") > 0) {
    return agent.match(regStr_uc);
  }
  //qq
  if (agent.indexOf("QQ") > 0) {
    return agent.match(regStr_QQ);
  }
  // baidu
  if (agent.indexOf("baidu") > 0) {
    return agent.match(regStr_baidu);
  }
  return ["unknow"];
}
export function getUserInfo() {
  return new Promise((resolve, reject) => {
    let browser = getBrowserInfo()[0]; //取到完整信息
    let UUID = $Cookies.get("UUID");
    let deviceId = $Cookies.get("deviceId");
    if (deviceId === undefined || deviceId === "") {
      let timeStr = new Date().getTime().toString();
      let str = Math.random().toString().slice(-6);
      deviceId = timeStr + str;
      $Cookies.set("deviceId", deviceId, {
        expires: 2000,
      });
    }
    let params = {
      UUID: UUID,
      browser: browser,
      deviceId: deviceId,
      domain: document.domain,
      ipInfo: "",
    };

    $api.post(
      $urls.USER.FIRSTUSERINFO,
      params,
      (resp) => {
        if (resp.data.code === 200) {
          let userInfo = resp.data.data;
          resolve(userInfo);
        } else {
          resp.data.msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(resp.data.msg);
        }
      },
      (err) => {
        reject(err.message);
      }
    );
  });
}
export function getBannerList(id) {
  return new Promise((resolve, reject) => {
    let params = {
      frontType: 2,
      position: id,
    };
    $api.post(
      $urls.HOMEBEFORE.BANNERLIST,
      params,
      (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          let arr = [];
          data.forEach((item) => {
            let obj = {};
            obj["img"] = item.picLink;
            obj["title"] = item.picContent;
            arr.push(obj);
          });
          resolve(arr);
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg);
        }
      },
      (err) => {}
    );
  });
}
export function getFirstNavList(str) {
  return new Promise((resolve, reject) => {
    let params = {
      frontType: 2,
    };
    $api.post(
      $urls.HOMEBEFORE.FIRSTNAVLIST,
      params,
      (resp) => {
        if (resp.data.code === 200) {
          let id = 0;
          let data = resp.data.data;
          data.forEach((item) => {
            if (item.navName === str) {
              id = item.id;
            }
          });
          resolve(id);
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg);
        }
      },
      (err) => {}
    );
  });
}

// 登录信息
export function logedUserInfo() {
  let browser = getBrowserInfo()[0];
  let UUID = $Cookies.get("UUID");
  let deviceId = $Cookies.get("deviceId");
  if (deviceId === undefined || deviceId === "") {
    let timeStr = new Date().getTime().toString();
    let str = Math.random().toString().slice(-6);
    deviceId = timeStr + str;
    $Cookies.set("deviceId", deviceId, {
      expires: 2000,
    });
  }

  let params = {
    UUID: UUID,
    browser: browser,
    deviceId: deviceId,
    // domain: document.domain,
    // ipInfo: ' ',
  };

  $api.post(
    $urls.HOMEAFTER.logedUserInfo,
    params,
    (resp) => {
      if (resp.data.code === 200) {
        deviceInfo();
      } else {
      }
    },
    (err) => {}
  );
}
// 获取系统及版本
export function getOsInfo() {
  var userAgent = navigator.userAgent.toLowerCase();
  var name = "Unknown";
  var version = "Unknown";
  if (userAgent.indexOf("win") > -1) {
    name = "Windows";
    if (userAgent.indexOf("windows nt 5.0") > -1) {
      version = "Windows 2000";
    } else if (
      userAgent.indexOf("windows nt 5.1") > -1 ||
      userAgent.indexOf("windows nt 5.2") > -1
    ) {
      version = "Windows XP";
    } else if (userAgent.indexOf("windows nt 6.0") > -1) {
      version = "Windows Vista";
    } else if (
      userAgent.indexOf("windows nt 6.1") > -1 ||
      userAgent.indexOf("windows 7") > -1
    ) {
      version = "Windows 7";
    } else if (
      userAgent.indexOf("windows nt 6.2") > -1 ||
      userAgent.indexOf("windows 8") > -1
    ) {
      version = "Windows 8";
    } else if (userAgent.indexOf("windows nt 6.3") > -1) {
      version = "Windows 8.1";
    } else if (
      userAgent.indexOf("windows nt 6.2") > -1 ||
      userAgent.indexOf("windows nt 10.0") > -1
    ) {
      version = "Windows 10";
    } else {
      version = "Unknown";
    }
  } else if (userAgent.indexOf("iphone") > -1) {
    name = "Iphone";
  } else if (userAgent.indexOf("mac") > -1) {
    name = "Mac";
  } else if (
    userAgent.indexOf("x11") > -1 ||
    userAgent.indexOf("unix") > -1 ||
    userAgent.indexOf("sunname") > -1 ||
    userAgent.indexOf("bsd") > -1
  ) {
    name = "Unix";
  } else if (userAgent.indexOf("linux") > -1) {
    if (userAgent.indexOf("android") > -1) {
      name = "Android";
    } else {
      name = "Linux";
    }
  } else {
    name = "Unknown";
  }
  var os = new Object();
  os.name = name;
  os.version = version;
  return os;
  //document.write("系统：" + os.name + "版本:" + os.name)
}
// 设备信息
export function deviceInfo() {
  let UUID = $Cookies.get("UUID");
  let deviceId = $Cookies.get("deviceId");

  let info = getOsInfo();
  let os = "",
    osVersion = "";
  info.name && (os = info.name);
  info.version && (osVersion = info.version);

  let params = {
    frontType: store.state.frontType,
    UUID: UUID,
    deviceId: deviceId,
    ip: "",
    clientTime: new Date().getTime(),
    isp: "",
    os: os,
    osVersion: osVersion,
    dns: "",
    dnsLocation: "",
    proxy: "",
    country: "",
    province: "",
    city: "",
    zipCode: "",
    timeZone: "",
    cookieEnable: "",
    jsEnable: "",
    flashEnable: "",
    javaEnable: "",
    activexEnable: "",
    webrtcEnable: "",
    vbEnable: "",
    adblockEnable: "",
    latitude: "",
    longitude: "",
    language: navigator.language,
    deviceMemory: "",
    maxTouchPoints: "",
    hardwareConcurrency: "",
    cpu: "",
    colorDepth: "",
    displayWidth: "",
    displayHeight: "",
  };
  $api.post(
    $urls.HOMEAFTER.DEVIVEINFO,
    params,
    (resp) => {
      if (resp.data.code === 200) {
      } else {
      }
    },
    (err) => {}
  );
}

export function getHeight(h) {
  let clientHeight = document.documentElement.clientHeight;
  let height = clientHeight - h;
  return height;
}
// 设置页面高度
export function handleScroll(str, h) {
  let height = "";
  let billBox = document.querySelector(str);
  let clientHeight = document.documentElement.clientHeight;
  if (clientHeight) {
    height = clientHeight - h;
    billBox.style.height = height + "px";
  }
}
// 设置页面最小高度
export function setMinHeight(str, h) {
  let height = "";
  let billBox = document.querySelector(str);
  let clientHeight = document.documentElement.clientHeight;
  if (clientHeight) {
    height = clientHeight + h;
    billBox.style.minHeight = height + "px";
  }
}
// 设置页面最大高度
export function setMaxHeight(str, h) {
  let height = "";
  let billBox = document.querySelector(str);
  let clientHeight = document.documentElement.clientHeight;
  if (clientHeight) {
    height = clientHeight - h;
    billBox.style.maxHeight = height + "px";
  }
}
//设置游戏页面最小高度
export function setMH(str, h) {
  let height = "";
  let billBox = document.querySelector(str);
  let clientHeight = document.documentElement.clientHeight;
  if (clientHeight) {
    height = clientHeight - h;
    billBox.style.minHeight = height + "px";
  }
}

// 首页导航分类
export const nav_list_arr = [
  // 1.真人 2. 体育 3. 老虎机 4.棋牌 5.捕鱼 6.彩票 7.个人中心 8.优惠
  // '/game/liveCasino','/game/sports','/game/slotMachine','/game/chess','/game/catchFish','/game/lottery','/signIn','/discounts',
  // '/mine',

  // 1.真人 2. 体育 3. 老虎机 4.棋牌 5.捕鱼 6.彩票 7.个人中心 8.优惠
  // gameType:1 - 老虎机，2-真人，3-体育，4-彩票，5-捕鱼王，6-棋牌，7-3D厅
  "/gameIndex/2",
  "/gameIndex/3",
  "/game/slotMachine",
  "/gameIndex/6",
  "/gameIndex/5",
  "/gameIndex/4",
  "/signIn",
  "/discounts",
  "/mine",
];
// 首页导航
export function sortIndexNav(type) {
  // 1.真人 2. 体育 3. 老虎机 4.棋牌 5.捕鱼 6.彩票 7.个人中心 8.优惠
  switch (type) {
    case 1:
      return nav_list_arr[type - 1];
    case 2:
      return nav_list_arr[type - 1];
    case 3:
      return nav_list_arr[type - 1];
    case 4:
      return nav_list_arr[type - 1];
    case 5:
      return nav_list_arr[type - 1];
    case 6:
      return nav_list_arr[type - 1];
    case 7:
      return nav_list_arr[type - 1];
    case 8:
      return nav_list_arr[type - 1];
  }
}
// 老虎机游戏拼接--收藏页
export function collectJoint(picLink, data) {
  if (data === null || data === undefined) {
    data = [];
    return data;
  } else {
    data.forEach((item) => {
      // if(item.platformCode==='HB'){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '_zh-CN.png';
      // }else if(jpgArr.includes(item.platformCode.toLowerCase())){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.jpg';
      // }else {
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.png';
      // }
      item["picLink"] = picLink + (item.h5Img ? item.h5Img : item.pcImg);
      item["collect"] = true;
    });

    return data;
  }
}
// bet365老虎机拼接
export function newJoint(picLink, data) {
  if (data === null || data === undefined) {
    data = [];
    return data;
  } else {
    data.forEach((item) => {
      item["picLink"] = picLink + (item.h5Img ? item.h5Img : item.pcImg);
    });
    return data;
  }
}
// 老虎机游戏拼接--未分页
export function oldJoint(picLink, data, mySlot) {
  if (mySlot === null || mySlot === "" || mySlot === undefined) {
    mySlot = [];
  }
  if (data === null || data === undefined) {
    data = [];
    return data;
  } else {
    data.forEach((item) => {
      // if(item.platformCode==='HB'){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '_zh-CN.png';
      // }else if(jpgArr.includes(item.platformCode.toLowerCase())){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.jpg';
      // }else {
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.png';
      // }
      item["picLink"] = picLink + (item.h5Img ? item.h5Img : item.pcImg);
      // item['href'] = `/api${src}?UUID=${UUID}&linkType=1&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}`
    });
    data.forEach((gamesItem) => {
      mySlot.forEach((myItem) => {
        if (gamesItem.id === myItem.id) {
          gamesItem["collect"] = true;
        }
      });
    });
    return data;
  }
}
// 老虎机游戏拼接
export function joint(picLink, resp, mySlot) {
  let data = resp.data.data.list;
  if (mySlot === null || mySlot === "" || mySlot === undefined) {
    mySlot = [];
  }
  if (data === null || data === []) {
    data = [];
    return data;
  } else {
    data.forEach((item) => {
      // if(item.platformCode==='HB'){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '_zh-CN.png';
      // }else if(jpgArr.includes(item.platformCode.toLowerCase())){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.jpg';
      // }else{
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.png';
      // }
      item["picLink"] = picLink + (item.h5Img ? item.h5Img : item.pcImg);
      // item['href'] = `/api${src}?UUID=${UUID}&linkType=1&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}`
    });
    data.forEach((gamesItem) => {
      mySlot.forEach((myItem) => {
        if (gamesItem.id === myItem.id) {
          gamesItem["collect"] = true;
        }
      });
    });
    return data;
  }
}

// 进入老虎机游戏
export function goSlotGame(item, isLogin, UUID, $router, type = 0) {
  // let gameType = item.gameType || 1;
  // let src = isLogin ? "/game/forward" : "/game/guest/forward";
  // let href = `/api${src}?UUID=${UUID}&linkType=1&platformCode=${
  //   item.platformCode
  // }&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${
  //   item.gameId
  // }&lang=${lang()}`;
  // if (type === 0) window.open(href);
  // if (type === 1) return href;

  const params = {
    UUID: UUID,
    linkType: 1,
    platformCode: item.platformCode,
    platformKey: item.fullName,
    gameType: item.gameType,
    gameCode: item.gameId,
  };
  store.commit("updateLoadingStatus", { isLoading: true });
  commonApi.GAME.getGameUrl(isLogin, params)
    .then((res) => {
      if (res.code === 200) {
        // if (type === 0) window.open(res.data);
        // if (type === 0) window.location.href = res.data;
        if (type === 0) {
          $router.push({
            path: "/game-play",
            query: {
              url: res.data,
              backUrl: window.location.href.replace(window.location.origin, ""),
            },
          });
        }
        if (type === 1) return res.data;
      } else {
        Toast({ message: res.msg || res.message, icon: "warning" });
      }
    })
    .catch((err) => {
      Toast({ message: err.message, icon: "warning" });
    })
    .finally(() => {
      store.commit("updateLoadingStatus", { isLoading: false });
    });
}

// 试玩老虎机游戏
export function trySlotGame(item) {
  let gameType = 1;
  let src = "/game/guest/forward";
  let href = `/api${src}?linkType=1&platformCode=${
    item.platformCode
  }&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${
    item.gameId
  }&lang=${lang()}`;
  window.open(href);
}
//获取是否有维护
export function getUpload({ platformKey }) {
  let maintain = "0"; // 1 维护中
  let list = store.state.allgameInfo.filter(
    (k) => k.platformKey == platformKey
  );
  if (list.length > 0) {
    maintain = list[0].maintain;
    store.commit("setupholdInfo", list[0].maintainRemarks);
  }
  return maintain;
}
export function getSlotUpload({ fullName }) {
  // 游戏 maintain 为1 维护中 maintainRemarks 维护内容
  let maintain = "0"; // 1 维护中
  let list = store.state.allgameInfo.filter((k) => k.platformKey == fullName);
  if (list.length > 0) {
    maintain = list[0].maintain;
    store.commit("setupholdInfo", list[0].maintainRemarks);
  }
  return maintain;
}
// 进入真人娱乐，体育等有游戏
export function goGame(item, isLogin, UUID, $router, type = 0) {
  // let src = isLogin ? "/game/gameUrl" : "/game/guest/gameUrl";
  // let href = `/api${src}?UUID=${UUID}&linkType=1&platformCode=${
  //   item.platformCode
  // }&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang()}`;

  const params = {
    UUID: UUID,
    linkType: 1,
    platformCode: item.platformCode,
    platformKey: item.platformKey,
    gameType: item.gameType,
  };
  store.commit("updateLoadingStatus", { isLoading: true });
  commonApi.GAME.getGameUrl(isLogin, params)
    .then((res) => {
      if (res.code === 200) {
        // if (type === 0) window.open(res.data);
        // if (type === 0) window.location.href = res.data;
        if (type === 0) {
          $router.push({
            path: "/game-play",
            query: {
              url: res.data,
              backUrl: window.location.href.replace(window.location.origin, ""),
            },
          });
        }
        if (type === 1) return res.data;
      } else {
        Toast({ message: res.msg || res.message, icon: "warning" });
      }
    })
    .catch((err) => {
      Toast({ message: err.message, icon: "warning" });
    })
    .finally(() => {
      store.commit("updateLoadingStatus", { isLoading: false });
    });
}
//进入棋牌具体游戏
export function goSpecificGame(item, isLogin, UUID) {
  if (
    (!item.hasOwnProperty("gameType") || item.gameType === "6") &&
    item.hasOwnProperty("gameId")
  ) {
    // 具体游戏，老虎机/棋牌等
    let gameType = item.gameType ? item.gameType : 6;
    let src = isLogin ? "/game/forward" : "/game/guest/forward";
    let href = `/api${src}?UUID=${UUID}&linkType=1&platformCode=${
      item.platformCode
    }&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${
      item.gameId
    }&lang=${lang()}`;
    window.open(href);
  } else {
    let src = isLogin ? "/game/forward" : "/game/guest/forward";
    let href = `/api${src}?UUID=${UUID}&linkType=1&platformCode=${
      item.platformCode
    }&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang()}`;
    window.open(href);
  }
}

//进入捕鱼具体游戏
export function goSpecialFishGame(item, isLogin, UUID) {
  if (
    (!item.hasOwnProperty("gameType") || item.gameType === "5") &&
    item.hasOwnProperty("gameId")
  ) {
    // 具体游戏，捕鱼等
    let gameType = item.gameType ? item.gameType : 5;
    let src = isLogin ? "/game/forward" : "/game/guest/forward";
    let href = `/api${src}?UUID=${UUID}&linkType=1&platformCode=${
      item.platformCode
    }&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${
      item.gameId
    }&lang=${lang()}`;
    window.open(href);
  } else {
    let src = isLogin ? "/game/forward" : "/game/guest/forward";
    let href = `/api${src}?UUID=${UUID}&linkType=1&platformCode=${
      item.platformCode
    }&platformKey=${item.platformKey}&gameType=${item.gameType}&gameCode=${
      item.gameId
    }&lang=${lang()}`;
    window.open(href);
  }
}

export function tryGame(item) {
  let src = "/game/guest/forward";
  let href = `/api${src}?linkType=1&platformCode=${
    item.platformCode
  }&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang()}`;
  window.open(href);
}

// '----------------游戏平台匹配图片'
export function sortGame(gamePlatformList, PicInfoList) {
  let allGame = gamePlatformList;
  let info = PicInfoList;
  if (allGame.length > 0) {
    allGame.forEach((item) => {
      if (info.length > 0) {
        info.forEach((infoItem) => {
          if (item.platformKey === infoItem.platformKey) {
            item["logoPic"] = infoItem.logoPic;
            item["logoImg"] = infoItem.logoImg;
          }
        });
      }
    });
  }
  return allGame;
}
export function sortAllGame(gamePlatformList, PicInfoList) {
  let allGame = gamePlatformList;
  let info = PicInfoList;
  if (allGame.length > 0) {
    allGame.forEach((item) => {
      if (info.length > 0) {
        info.forEach((infoItem) => {
          if (item.platformKey === infoItem.platformKey) {
            item["logoPic"] = infoItem.logoImg;
          }
        });
      }
    });
  }
  return allGame;
}

//获取每个游戏前三个平台
export function getThreegame(gamePlatformList, PicInfoList) {
  let allGame = gamePlatformList;
  let info = PicInfoList;
  if (allGame.length > 0) {
    allGame.forEach((item) => {
      if (info.length > 0) {
        info.forEach((infoItem) => {
          if (item.platformKey === infoItem.platformKey) {
            item["logoPic"] = infoItem.logoPic;
          }
        });
      }
    });
  }
  let hot = [];
  let hotone = [];
  let hottwo = [];
  let hotthree = [];
  let hotfour = [];
  let hotfive = [];
  let hotsix = [];
  allGame.forEach((item, index) => {
    if (item.gameType == `2`) {
      hotone.push(item);
    }
    if (item.gameType == `3`) {
      hottwo.push(item);
    }
    if (item.gameType == `4`) {
      hotthree.push(item);
    }
    if (item.gameType == `1`) {
      hotfour.push(item);
    }
    if (item.gameType == `6`) {
      hotfive.push(item);
    }
    if (item.gameType == `5`) {
      hotsix.push(item);
    }
  });
  hot = hot.concat(
    hotone.slice(0, 3),
    hottwo.slice(0, 3),
    hotthree.slice(0, 3),
    hotfour.slice(0, 3),
    hotfive.slice(0, 3),
    hotsix.slice(0, 3)
  );
  return hot;
}

// 游戏平台流水数据处理
export function dataFilter(data) {
  if (data.length > 0) {
    let arr = [];
    data.forEach((item) => {
      let obj = {};
      obj["date"] = timeFilter(item.createTime);
      obj["value"] = item.flowNumber;
      arr.push(obj);
    });

    return arr.reverse();
  }
}
export function timeFilter(time) {
  return format("MM-dd", time).split("-").join("/");
}
// 调用App方法
export function emitAppMethods(methodsName, parmars) {
  if (/android/i.test(navigator.userAgent)) {
    // todo : android
    if (!window.android) return;
    try {
      // window.android[methodsName](parmars);
      // // window.android.methodsName(parmars);
      // // window.android.goOffer()
      // // window.android.JS_APP_WealthCenter()
      // window.android.JS_APP_GoBack()
      // window.android.JS_APP_GoBack()
      // window.android.nativeMethod(methodsName)
      // window.android.nativeMethod()
      switch (methodsName) {
        case "JS_APP_GoBack":
          window.android.JS_APP_GoBack();
          break;
        case "JS_APP_HOME":
          window.android.JS_APP_HOME();
          break;
        case "JS_APP_WealthCenter":
          window.android.JS_APP_WealthCenter();
          break;
        case "JS_APP_ActivityList":
          window.android.JS_APP_ActivityList();
          break;
        case "JS_APP_Withdrawal":
          window.android.JS_APP_Withdrawal();
          break;
        case "JS_APP_Deposit":
          window.android.JS_APP_Deposit();
          break;
        case "JS_APP_Registered":
          window.android.JS_APP_Registered();
          break;
        case "JS_APP_Login":
          window.android.JS_APP_Login();
          break;
        case "JS_APP_UserMange":
          window.android.JS_APP_UserMange();
          break;
        case "JS_APP_EuropeEvent":
          window.android.JS_APP_EuropeEvent();
          break;
      }
    } catch (err) {
      console.log(err);
    }
  } else if (/ipad|iphone|iPod|iOS|mac/i.test(navigator.userAgent)) {
    if (!window.webkit || !window.webkit.messageHandlers) return;
    let message = {
      method: methodsName,
      param: parmars,
    };
    try {
      window.webkit.messageHandlers.jsOpenSwiftFunc.postMessage(message);
    } catch (err) {
      console.log(err);
    }
  }
}
//app或h5调用的方法

export function testMethods(methodsName, parmars) {
  methodsName(parmars);
}
// 挂件跳转处理
export function goHref(url) {
  if (!url) return;

  if (
    url.indexOf(".qq.com") > -1 ||
    url.indexOf(".meiqia.com") > -1 ||
    url.indexOf("chat.livechatvalue.com") > -1 ||
    url.indexOf("live800") > -1
  ) {
    window.open(url, "");
  } else if (url.indexOf("tencent://") === 0) {
    window.location.href = url;
  } else if (url.startsWith("/")) {
    // return url.split('#')[1];
    return url;
  } else {
    window.open(url);
  }
  return false;
}

export default {
  Decrypt,
  Encrypt,
  setListOrder,
  setHotOrder,
  depositUrl,
  newDepositUrl,
  newDepositBankUrl,
  ForenewDepositUrl,
  bankurl,
  randomRange,
  loginOut,
  getInfo,
  serverInfo,
  gamePlatform,
  getMyslot,
  isCollect,
  slotJoint,
  safetyIndex,
  getBrowserInfo,
  getUserInfo,
  getBannerList,
  getFirstNavList,
  logedUserInfo,
  getOsInfo,
  deviceInfo,
  getHeight,
  handleScroll,
  setMinHeight,
  setMaxHeight,
  setMH,
  nav_list_arr,
  sortIndexNav,
  collectJoint,
  newJoint,
  oldJoint,
  joint,
  goSlotGame,
  trySlotGame,
  getUpload,
  getSlotUpload,
  goGame,
  goSpecificGame,
  tryGame,
  sortGame,
  sortAllGame,
  getThreegame,
  dataFilter,
  timeFilter,
  emitAppMethods,
  testMethods,
  goHref,
};



// WEBPACK FOOTER //
// ./src/common/utils/common.js